// we need to maintain a fix order of vendors that will be called or the build will produce an error (as we have multiple entry points)
import 'assets/core/js/module/selectManager'

import ProductSummary from '@ui/Product/Summary/component'
import { yieldToMain } from 'assets/core/js/common'
import product from 'assets/core/js/entry/product'
import GoTop from 'assets/core/js/module/goTop'
import HashManager from 'assets/core/js/module/hashManager'
import lastSeen from 'assets/core/js/module/lastSeen'
import dataLayer from 'assets/core/js/page/product/dataLayer'
import goBack from 'assets/core/js/page/product/goBack'
import presentation from 'assets/core/js/page/product/presentation'
import facets from 'assets/core/js/page/product/search/facets'
import zoomMediasPanel from 'assets/core/js/page/product/zoomMediasPanel'
import partials from 'assets/themes/campings/js/module/partials'
import bestOffer from 'assets/themes/campings/js/page/product/bestOffer'
import calendar from 'assets/themes/campings/js/page/product/calendar'
import filters from 'assets/themes/campings/js/page/product/filters'
import imagesSliders from 'assets/themes/campings/js/page/product/imagesSliders'
import shareModal from 'assets/themes/campings/js/page/product/modal/share'
import navigation from 'assets/themes/campings/js/page/product/navigation'
import properties from 'assets/themes/campings/js/page/product/properties'
import results from 'assets/themes/campings/js/page/product/results'
import reviews from 'assets/themes/campings/js/page/product/reviews'
import scrollToTarget from 'assets/themes/campings/js/page/product/scrollToTarget'
import search from 'assets/themes/campings/js/page/product/search'
import sidePanels from 'assets/themes/campings/js/page/product/sidePanels'

const productFacets = facets.init()
HashManager.init()

document.addEventListener('DOMContentLoaded', function () {
  // must be called before search
  partials()
  product()

  sidePanels()
  // keep this call before the others non critical as it can trigger offers refresh
  search(productFacets)
  // Initialize partials after the search to prevent a double update.

  bestOffer()
  dataLayer('.result__card[data-id]')
  navigation()
  scrollToTarget()
  filters()
  shareModal()
  results()
  calendar()
  zoomMediasPanel()

  void (async () => {
    await yieldToMain()
    imagesSliders()
    ProductSummary()
    goBack()
    GoTop('.product__section.product__images')
    properties()
    presentation()
    reviews()
    lastSeen()
  })()
})
